<flx-flex-container>
	<flx-heading type="page" size="medium">Reminders</flx-heading>
	<ng-container *ngIf="reminders">
		<div *ngFor="let rem of reminders"><flx-reminder-card [reminder]="rem" (reminderCardCommand)="reminderCardCommandHandler($event)"> </flx-reminder-card></div>
	</ng-container>
	<flx-add-reminder (addReminder)="addReminder($event)" (updateReminder)="updateReminder($event)"></flx-add-reminder>
</flx-flex-container>
